import { xhrApiClient } from '../../../config/xhrApiClient'

const postSubmitOrder = async (payload: any) => {
    const { data } = await xhrApiClient.post(`/api/submit-order`, payload)
    return data
}

export default postSubmitOrder
